import { Component } from '@angular/core';
import { LicenseService } from '../../core/services/http-services/license.service';
import { ErrorPagesComponent } from './error-pages.component';
import { AppConstants } from '../../app.constants';

@Component({
  styleUrls: ['./error-pages.scss'],
  templateUrl: './error-pages.component.html'
})

export class NotFoundErrorPageComponent extends ErrorPagesComponent {
  constructor(
    protected readonly licenseService: LicenseService
  ) {
    super(licenseService);
    this.errorCode = 404;
    this.errorTitle = 'Nothing was found';
    this.errorDescription = AppConstants.NOT_FOUND_PAGE_ERROR_MESSAGE;
  }
}
